export default __webpack_public_path__ + "static/media/solidario13.0014449d.jpeg";